import React from "react";
import { string, object, number, func, any } from "prop-types";
import {
    OptionCheckBoxGroup,
    OptionCheckBox
} from "../Components/OptionsCheckBox";
import Select from "react-select";
import Button from "../Components/Button";
import { Range, Handle, createSliderWithTooltip } from "rc-slider";
import ToolTip from "rc-tooltip";
import ResizeContext from "./../Contexts/ResizeContext";
import { Portal } from "../Components/Portal";
import FilterButton from "../Components/FilterButton";

const NewRange = createSliderWithTooltip(Range);

const handle = props => {
    const { value, dragging, index, ...restProps } = props;

    handle.propTypes = {
        value: any,
        dragging: any,
        index: any
    };

    return (
        <ToolTip
            prefixCls="rc-slider-tooltip"
            overlay={value}
            visible={dragging}
            placement="top"
            key={index}>
            <Handle value={value} {...restProps} />
        </ToolTip>
    );
};

export default class FacetSidebar extends React.Component {
    constructor(props) {
        super(props);

        let facetFields = {};

        Object.entries(props.facetCounts.facet_fields).forEach(([field]) => {
            facetFields[field] = [];
        });

        Object.entries(props.facetCounts.facet_ranges).forEach(
            ([field, range]) => {
                facetFields[field] = {
                    range: [range.start, range.end]
                };
            }
        );

        this.state = {
            ...facetFields,
            toggleState: false
        };

        this.togglePopout = this.togglePopout.bind(this);
    }

    componentDidMount() {
        let state = Object.assign({}, this.state);
        let { initiallySelectedOptions } = this.props;

        Object.entries(initiallySelectedOptions).forEach(([key, values]) => {
            if (state[key] && this.props.facetCounts.facet_fields[key]) {
                state[key] = [];

                values.split(",").forEach(value => {
                    let stateValue;

                    if (key == "quote_status_facet") {
                        stateValue = Object.keys(
                            this.props.facetCounts.facet_fields[key]
                        ).find(idAndName => idAndName.includes(value));
                    } else {
                        stateValue = Object.keys(
                            this.props.facetCounts.facet_fields[key]
                        ).find(idAndName => idAndName.includes(`${value}_`));
                    }

                    state[key].push({
                        field: key,
                        value: stateValue
                    });
                });
            }
        });
        this.setState(state);
    }

    togglePopout() {
        const toggleState = this.state.toggleState
            ? !this.state.toggleState
            : true;

        this.setState({ toggleState });
    }

    render() {
        let counter = 0;

        return (
            <React.Fragment>
                {this.context.isMobile && (
                    <Portal node="#filter-btn">
                        <FilterButton onClick={this.togglePopout} />
                    </Portal>
                )}
                <div
                    className={`facet-sidebar ${this.context.isMobile &&
                        `facet-mobile
                        ${this.state.toggleState ? "open" : "close"}`}`}>
                    {this.context.isMobile && (
                        <div
                            className="filter-close"
                            onClick={this.togglePopout}>
                            X
                        </div>
                    )}
                    <h2 className="title h1-clone" key="sidebar-title">
                        {this.props.title}
                    </h2>
                    <div key="sidebar" className="sidebar">
                        <div className="options">
                            {Object.entries(
                                this.props.facetCounts.facet_fields
                            ).map(([field, options]) => {
                                if (this.state[field]) {
                                    counter = 0;

                                    let searchOptions = [],
                                        fieldTitle = field.includes("_")
                                            ? field.split("_")[0]
                                            : field,
                                        otherOptions = [];

                                    if (fieldTitle == "quote") {
                                        fieldTitle = "Listing Type";
                                    }

                                    let stateField = this.state[field];

                                    return (
                                        <OptionCheckBoxGroup
                                            key={field}
                                            title={fieldTitle}
                                            showClearAll={
                                                this.state[field].length > 0
                                            }
                                            clearAllButtonOnClick={() => {
                                                this.setState(
                                                    {
                                                        [field]: []
                                                    },
                                                    this.props.resetSelectedFieldOptions(
                                                        field
                                                    )
                                                );
                                            }}>
                                            {Object.entries(options).map(
                                                ([key, count]) => {
                                                    if (key != "null") {
                                                        let name = key.includes(
                                                            "_"
                                                        )
                                                            ? key.split("_")[1]
                                                            : key;

                                                        if (
                                                            name.includes(
                                                                "&amp;"
                                                            )
                                                        ) {
                                                            name = name.replace(
                                                                "&amp;",
                                                                "&"
                                                            );
                                                        }
                                                        if (
                                                            fieldTitle ==
                                                                "Listing Type" &&
                                                            name == 0
                                                        ) {
                                                            name = "Buy Now";
                                                        }
                                                        if (
                                                            fieldTitle ==
                                                                "Listing Type" &&
                                                            name == 1
                                                        ) {
                                                            name =
                                                                "Request a Quote";
                                                        }

                                                        let option = {
                                                            field: field,
                                                            label: `${name} (${count})`,
                                                            value: key
                                                        };

                                                        if (
                                                            name.toLowerCase() ==
                                                                "other" ||
                                                            name.toLowerCase() ==
                                                                "not specified"
                                                        ) {
                                                            if (
                                                                Object.keys(
                                                                    options
                                                                ).length >
                                                                this.props
                                                                    .optionLimit
                                                            ) {
                                                                searchOptions.push(
                                                                    option
                                                                );
                                                            } else {
                                                                otherOptions.push(
                                                                    option
                                                                );
                                                            }
                                                            return null;
                                                        }

                                                        counter++;

                                                        if (
                                                            counter <
                                                            this.props
                                                                .optionLimit
                                                        ) {
                                                            let optionIndexInStateField = stateField.findIndex(
                                                                item =>
                                                                    option.value ==
                                                                    item.value
                                                            );

                                                            return (
                                                                <OptionCheckBox
                                                                    key={key}
                                                                    name={`${name} (${count})`}
                                                                    checked={
                                                                        optionIndexInStateField >=
                                                                        0
                                                                    }
                                                                    value={key}
                                                                    onClick={() => {
                                                                        if (
                                                                            optionIndexInStateField >=
                                                                            0
                                                                        ) {
                                                                            stateField.splice(
                                                                                optionIndexInStateField,
                                                                                1
                                                                            );
                                                                        } else {
                                                                            stateField.push(
                                                                                option
                                                                            );
                                                                        }

                                                                        this.setState(
                                                                            {
                                                                                [field]: stateField
                                                                            },
                                                                            this.props.returnSelectedOptions(
                                                                                this
                                                                                    .state[
                                                                                        field
                                                                                    ],
                                                                                field
                                                                            )
                                                                        );
                                                                    }}
                                                                />
                                                            );
                                                        } else {
                                                            searchOptions.push(
                                                                option
                                                            );
                                                        }
                                                    } else {
                                                        return null;
                                                    }
                                                }
                                            )}
                                            {searchOptions.length > 0 ? (
                                                <Select
                                                    className="sidebar-option"
                                                    multi
                                                    options={searchOptions}
                                                    onChange={selected => {
                                                        this.setState(
                                                            {
                                                                [field]: selected
                                                            },
                                                            this.props.returnSelectedOptions(
                                                                selected,
                                                                field
                                                            )
                                                        );
                                                    }}
                                                    value={this.state[field]}
                                                />
                                            ) : (
                                                otherOptions.length > 0 &&
                                                otherOptions.map(
                                                    otherOption => {
                                                        let {
                                                            field,
                                                            label,
                                                            value
                                                        } = otherOption;
                                                        let optionIndexInStateField = stateField.findIndex(
                                                            item =>
                                                                value ==
                                                                item.value
                                                        );

                                                        return (
                                                            <OptionCheckBox
                                                                key={value}
                                                                name={label}
                                                                checked={
                                                                    optionIndexInStateField >=
                                                                    0
                                                                }
                                                                value={value}
                                                                onClick={() => {
                                                                    if (
                                                                        optionIndexInStateField >=
                                                                        0
                                                                    ) {
                                                                        stateField.splice(
                                                                            optionIndexInStateField,
                                                                            1
                                                                        );
                                                                    } else {
                                                                        stateField.push(
                                                                            otherOption
                                                                        );
                                                                    }

                                                                    this.setState(
                                                                        {
                                                                            [field]: stateField
                                                                        },
                                                                        this.props.returnSelectedOptions(
                                                                            this
                                                                                .state[
                                                                                    field
                                                                                ],
                                                                            field
                                                                        )
                                                                    );
                                                                }}
                                                            />
                                                        );
                                                    }
                                                )
                                            )}
                                        </OptionCheckBoxGroup>
                                    );
                                } else {
                                    return null;
                                }
                            })}
                            {Object.entries(
                                this.props.facetCounts.facet_ranges
                            ).map(([field, range]) => {
                                let min = 0,
                                    max = 10000;

                                if (range.counts.length > 2) {
                                    (min = Number(range.counts[0])),
                                    (max = Number(
                                        range.counts[
                                            range.counts.length - 2
                                        ]
                                    ));
                                }

                                return (
                                    <OptionCheckBoxGroup
                                        key={`${field}-range-filter`}
                                        title={field}
                                        showClearAll={
                                            this.state[field].range !=
                                            [range.start, range.end]
                                        }
                                        clearAllButtonOnClick={() => {
                                            let newOptionsState = this.state;

                                            newOptionsState[field].range = [
                                                range.start,
                                                range.end
                                            ];

                                            this.setState(
                                                newOptionsState,
                                                this.props.resetSelectedFieldOptions(
                                                    field
                                                )
                                            );
                                        }}>
                                        <NewRange
                                            min={min}
                                            max={max}
                                            allowCross={false}
                                            value={this.state[field].range}
                                            onChange={newRange => {
                                                let newOptionsState = this
                                                    .state;

                                                newOptionsState[
                                                    field
                                                ].range = newRange;

                                                this.setState(newOptionsState);
                                            }}
                                            onAfterChange={() => {
                                                this.props.returnSelectedOptions(
                                                    this.state[field],
                                                    field
                                                );
                                            }}
                                            marks={{
                                                [min]: `$${min}`,
                                                [max]: "Max"
                                            }}
                                            handle={handle}
                                        />
                                    </OptionCheckBoxGroup>
                                );
                            })}
                            {this.context.isMobile && (
                                <OptionCheckBoxGroup key="apply-filters">
                                    <Button
                                        label="Apply Filters"
                                        className="btn btn-lx btn-block"
                                        onClick={this.togglePopout}
                                    />
                                </OptionCheckBoxGroup>
                            )}
                            <OptionCheckBoxGroup key="clear-filters">
                                <Button
                                    label="Clear Filters"
                                    className="btn btn-outline-lx btn-block"
                                    onClick={() => {
                                        let facetFields = {};

                                        Object.entries(
                                            this.props.facetCounts.facet_fields
                                        ).forEach(([field]) => {
                                            facetFields[field] = [];
                                        });
                                        Object.entries(
                                            this.props.facetCounts.facet_ranges
                                        ).forEach(([field, range]) => {
                                            facetFields[field] = {
                                                range: [range.start, range.end]
                                            };
                                        });

                                        this.setState({ ...facetFields });
                                        this.props.resetSelectedOptions();
                                    }}
                                />
                            </OptionCheckBoxGroup>
                        </div>
                    </div>
                    {!this.context.isMobile && (
                        <div
                            key="additionl-side-content"
                            className="additionl-side-content">
                            {this.props.children}
                        </div>
                    )}
                </div>
            </React.Fragment>
        );
    }
}

FacetSidebar.contextType = ResizeContext;

FacetSidebar.defaultProps = {
    optionLimit: 10
};

FacetSidebar.propTypes = {
    title: string,
    facetCounts: object,
    initiallySelectedOptions: object,
    returnSelectedOptions: func,
    resetSelectedFieldOptions: func,
    resetSelectedOptions: func,
    applyFilters: func,
    optionLimit: number,
    children: any
};
